const Home = () => {
  return (
    <section id="home">
      <div className="container">
        <div className="row">
          <h1>Hi there! I'll be updating this app very soon </h1>
          <div className="col-md-offset-2 col-md-8">
            <h1 className="wow fadeIn" dataWowOffset="50" dataWowDelay="0.9s">
              I make Web app that are <span>awesome</span>
            </h1>
            <div className="element">
              <div className="sub-element">Hello, there!</div>
              <div className="sub-element">
                I'm a Future Fullsatck developer but
              </div>
              <div className="sub-element">
                Currently I'm a Frontend Developer
              </div>
            </div>
            <a
              data-scroll
              href="#about"
              className="btn btn-default wow fadeInUp border border-light"
              data-wow-offset="50"
              data-wow-delay="0.6s"
            >
              GET STARTED
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
